import FArray from '@/plugins/form/FArray';
import Item from './Item';
import Buyer from './Buyer';

export default class extends FArray {
  buyer = new Buyer();

  type = 'pay';

  payer = 'agency';

  constructor(props) {
    super(props);
    this.$subscribe(() => {
      this.buyer.setTouristOptions(this.items.filter(i => i.age.value?.value === 0));
    });
  }


  get data() {
    const {buyer} = this;
    let buyerOrderIndex = buyer.value.tourist?.value;
    if (buyerOrderIndex) {
      buyerOrderIndex -= 1;
      return this.items.map((i, j) => {
        if (j === buyerOrderIndex) {
          return {
            ...buyer.data,
            IsMain: true,
            IsTourist: i.data.IsTourist,
            FirstName: i.data.FirstName,
            LastName: i.data.LastName,
            MiddleName: i.data.MiddleName,
            Gender: i.data.Gender,
            AgeCategory: i.data.AgeCategory,
            DateOfBirth: i.data.DateOfBirth,
            DocumentNumber: i.data.DocumentNumber,
            DocumentDateOfIssuance: i.data.DocumentDateOfIssuance,
            TypeOfDocument: i.data.TypeOfDocument
          };
        }
        return i.data;
      });
    }
    return [
      ...this.items.map(i => i.data),
      this.buyer.data,
    ];
  }

  set data(value) {
    this.__value = [];
    value.forEach((i) => {
      const item = new Item();
      this.push(item);
      item
        .setData(i)
        .init();
    });
  }

  $validate() {
    return Promise.all([
      super.$validate(),
      this.payer === 'client' ? this.buyer.$validate() : null,
    ]);
  }

  add(values) {
    const item = new Item();
    this.push(item);
    return item
      .set(values)
      .init()
      .then(() => {
        if (!values.citizenship) {
          const citizenship = item.citizenship.options.find(i => i.label === 'РФ');
          item.citizenship.set(citizenship);
        }
        return item;
      });
  }

  addChild({ gender }) {
    return this
      .add({
        age: {
          value: 1,
          label: 'Ребенок',
        },
        gender: gender || {
          value: 'MAN',
          label: 'Мужской',
        },
        documentType: {
          value: 'PASSPORT',
          label: 'Паспорт РФ',
        },
      })
      .then((item) => {
        item.documentType.options = [
          {
            value: 'PASSPORT',
            label: 'Паспорт РФ',
          },
          {
            value: 'BIRTH_NOTIFICATION',
            label: 'Сведетельство о рождении',
          },
        ];
        return item;
      });
  }

  addAdult({ gender }) {
    return this
      .add({
        age: {
          value: 0,
          label: 'Взрослый',
        },
        gender: gender || {
          value: 'MAN',
          label: 'Мужской',
        },
        documentType: {
          value: 'PASSPORT',
          label: 'Паспорт РФ',
        },
      })
      .then((item) => {
        item.documentType.options = [
          {
            value: 'PASSPORT',
            label: 'Паспорт РФ',
          },
          {
            value: 'FOREIGN_PASSPORT',
            label: 'Загран. Паспорт',
          },
        ];
        return item;
      });
  }

  async set(data) {
    await this.setTourists(data);
    this.buyer.setTouristOptions(this.items.filter(i => i.age.value.value === 0));
    if (this.buyer.tourist.options[1]) {
      this.buyer.tourist.set(this.buyer.tourist.options[1]);
    }
    this.buyer.documentType.set({
      value: 'PASSPORT',
      label: 'Паспорт РФ',
    });
    this.buyer.gender.set({
      value: 'MAN',
      label: 'Мужской',
    });
    await this.buyer.init();
    const citizenship = this.buyer.citizenship.options.find(i => i.label === 'РФ');
    this.buyer.citizenship.set(citizenship);
    return this;
  }

  setTourists(data) {
    this.__value = [];
    return Promise.all([
      ...(new Array(data.adults).fill(''))
        .map((_, idx) => this.addAdult({
          gender: idx % 2
            ? {
              value: 'WOMAN',
              label: 'Женский',
            }
            : {
              value: 'MAN',
              label: 'Мужской',
            },
        })),
      ...(new Array(data.children).fill(''))
        .map((_, idx) => this.addChild({
          gender: idx % 2
            ? {
              value: 'WOMAN',
              label: 'Женский',
            }
            : {
              value: 'MAN',
              label: 'Мужской',
            },
        })),
    ]);
  }
}
